// File: general-template-1.js
// Import Cumulo
import Cumulo from '../modules/cumulo.js';

class GeneralTemplate1Renderer extends Cumulo {
    onEnter() {
    }
}

// Don`t forget to export your renderer
export default GeneralTemplate1Renderer;